<template>
  <v-select
    class="tema-combo"
    id="temas-select"
    v-model="chooseTemas"
    item-text="nome"
    :items="temas"
    :label="name"
    :return-object="true"
    :placeholder="name"
    v-on:change="$emit('onChange', chooseTemas)"
    :disabled="disabled"
    multiple
    clearable
  >
    <template slot="no-data"> Nenhum Tema </template>
  </v-select>
</template>

<script>
import { temaAPI } from "../API/temaAPI";
import { mapActions } from "vuex";

import seloEvidenceReadScopeMixin from "@/utils/seloEvidenceReadScopeMixin";

export default {
  mixins: [seloEvidenceReadScopeMixin],
  name: "AppTemaCombobox",
  props: {
    disabled: { type: Boolean, default: false },
    name: { type: String, default: "Temas" },
  },
  mounted() {
    this.loadTemas();
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadTemas() {
      temaAPI
        .list()
        .then((resp) => {
          this.temas = resp.data;

          if (!this.consultaCompletaSelo && !this.user.grupo.verTodosEixos) {
            this.temas = this.temas.filter((item) =>
              this.user.permissoes.some((per) => per.eixoId === item.eixoId)
            );
          }
        })
        .catch(() => {
          this.$notification.error("Erro ao obter Temas");
        });
    },
  },
  data() {
    return {
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      temas: [],
      chooseTemas: [],
      user: JSON.parse(localStorage.getItem("user")),
    };
  },
};
</script>

<style scoped>
.tema-eixo-combo {
  padding: 0 24px 20px;
}
</style>
